// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Yo0M","rightAdornment":"Header_rightAdornment__12hBB"};